import { useEffect, useState } from 'react';

const useAudioPermission = () => {
  const [granted, setGranted] = useState(false);
  const [hasDevice, setHasDevice] = useState(false);

  const store = ({ state }) => {
    localStorage.setItem('VoiceMessage', JSON.stringify({ granted: state }));
  };

  const get = () => {
    const data = localStorage.getItem('VoiceMessage');
    if (data) {
      return JSON.parse(data).granted;
    }
    return false;
  };

  const getUserAudio = async () => {
    try {
      const media = await navigator.mediaDevices.getUserMedia({ audio: true });
      setGranted(true);
      store({ state: true });
      return media;
    } catch (e) {
      setGranted(false);
      store({ state: false });
      throw new Error(`useAudioPermission#getUserAudio(): ${e.message}`);
    }
  };

  useEffect(() => {
    if (typeof navigator.permissions !== 'undefined') {
      (async () => {
        try {
          const { state } = await navigator.permissions.query({ name: 'microphone' });
          setGranted(state === 'granted');
        } catch (e) {
          setGranted(false);
        }
      })();
    } else {
      setGranted(get());
    }
  }, []);

  useEffect(() => {
    (async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();
      setHasDevice(devices.filter(({ kind }) => kind === 'audioinput').length > 0);
    })();
  }, [granted]);

  return {
    granted,
    hasDevice,
    getUserAudio,
  };
};

export default useAudioPermission;
